import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import { Container, Tab, Tabs, Box } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import ButtonBackPage from "@components/ButtonBackPage";
import TableRda from "./TableAccounting/TableRda";
import TableBCBE from "./TableAccounting/TableBCBE";
import TableOda from "./TableAccounting/TableOda";
import TableGoodsReceipts from "./TableAccounting/TableGoodsReceipts";
import { useTheme } from "@mui/material";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";

const Accounting: React.FC = () => {
  const { t } = useTranslation(["accounting-page"]);
  const [selectedTab, setSelectedTab] = useState(0);
  const { id } = useParams();
  const theme = useTheme();

  const { dataDetail: dataBook, mutate: mutateBook } = useFetchDetail(
    `${ServicesURL.getBookKeepingStats}`,
    `?corporateId=${id}` || "",
  );

  const handleTabChange = (newValue: number) => {
    setSelectedTab(newValue);
  };

  const tabs = [
    {
      id: "rda",
      label: (
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          {t("tab.rda")} -{" "}
          <span
            style={{ color: theme.palette.status.blocked, marginLeft: "4px" }}
          >
            {dataBook.rda?.pending_approval_count}
          </span>
        </div>
      ),
      component: <TableRda stats={dataBook?.rda} mutateBook={mutateBook} />,
    },
    {
      id: "bc_be",
      label: (
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          {t("tab.bc_be")} -{" "}
          <span
            style={{ color: theme.palette.status.blocked, marginLeft: "4px" }}
          >
            {dataBook.bc_be?.pending_approval_count}
          </span>
        </div>
      ),
      component: <TableBCBE stats={dataBook?.bc_be} mutateBook={mutateBook} />,
    },
    {
      id: "oda",
      label: (
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          {t("tab.oda")} -{" "}
          <span
            style={{ color: theme.palette.status.blocked, marginLeft: "4px" }}
          >
            {dataBook.po?.to_be_issued_count}
          </span>
        </div>
      ),
      component: <TableOda stats={dataBook?.po} mutateBook={mutateBook} />,
    },
    {
      id: "goods-receipts",
      label: (
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          {t("tab.goods-receipts")} -{" "}
          <span
            style={{ color: theme.palette.status.blocked, marginLeft: "4px" }}
          >
            {dataBook.gr?.pending_approval_count}
          </span>
        </div>
      ),
      component: (
        <TableGoodsReceipts stats={dataBook?.gr} mutateBook={mutateBook} />
      ),
    },
  ];

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-accounting.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${t("hero-title")}`}
          description={t("hero-description")}
        />
        <ButtonBackPage />
        <Box>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#696969",
              zIndex: 2000,
              background: theme.palette.text.secondary,
            }}
          >
            <Tabs
              value={selectedTab}
              aria-label="table tabs"
              sx={{
                "& .MuiTab-root": {
                  color: theme.palette.text.primary,
                  textTransform: "none",
                  fontSize: "1.5rem",
                  position: "relative",
                  "&.Mui-selected::after": {
                    content: '""',
                    display: "block",
                    width: "100%",
                    height: "3px",
                    backgroundColor: theme.palette.accent.main,
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                  },
                },
                "& .MuiTab-root.Mui-selected": {
                  color: theme.palette.accent.main,
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={tab.id}
                  label={tab.label}
                  onClick={() => handleTabChange(index)}
                />
              ))}
            </Tabs>
          </Box>
          <Box>{tabs[selectedTab]?.component}</Box>
        </Box>
      </Container>
    </AnimationFadeIn>
  );
};

export default Accounting;
